import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { authRoutes } from '@web-frontend/core/auth/auth-routing.module';

@Injectable({ providedIn: 'root' })
export class OnboardingRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (state.url.includes(authRoutes.onboarding)) {
      this.router.navigate([authRoutes.aiform], {
        queryParams: route.queryParams,
      });
      return false;
    }
    return true;
  }
}
